export default __webpack_public_path__ + "static/carousel_image_3_cannes-5c10c36e4d9860ae526b145b20f042b5.jpg";